window.Galery = {
	
	init: function(){
		
		$('.galery-images .image-row').unbind('click').click(function(){
			$('.galery-images .current').removeClass('current');
			$(this).parent().addClass('current');

			if ($('.image-row').length == 1) {
				var src = $(this).find('img').attr('src');
				$('.galery-image img.main').attr('src', src);
			}
			
		});
		
	},
	
	addOne: function(data){
		var newRow = $('.galery-images .main-image-row').clone();
		
		newRow.removeClass('main-image-row hidden');
		
		newRow.attr('id', data.galeryid);
		newRow.find('.button-delete').attr('onclick', 'Galery.deleteImage('+data.galeryid + ')');
		newRow.find('.button-default').attr('onclick', 'Galery.setDefaultImage('+data.galeryid+', ' + $('.galery').data('declid') +')');
		newRow.find('.image img').attr('src', data.public_path);
		
		if ($('.image-row').length == 1){
			newRow.addClass("current default-yes");
			$('.main-details .avatar-picture img').attr('src', data.public_path);
		}
		
		$('.galery-container .no-image').hide();
		$('.galery-images ul').append(newRow);
		$('.galery-image, .galery-images').show();
		
		Galery.init();
		newRow.find('.image-row').trigger('click');
		
		return true;
	},

	refreshLast: function(data){

		window.img_src = '';
		if (data !== undefined && data[0] !== undefined) {
			img_src = data[0].public_path + '&' + Utils.generateRandom();
		}

		Galery.init();
		var d = new Date();
		var last = $('.galery-images li:last');

		window.img = last.find('.image img');

		if (img_src == ''){
			img_src = img.attr('src') + d.getTime();
		}

		img.attr('src', img_src);
		last.find('.image-row').trigger('click');

		$('.galery-images .placeholder').hide();
	},


	loadCrop: function(data){


		if (data.success){
			Galery.addOne(data);
			var galeryId = data.galeryid;
			var options = {
				noclose	: true,
				closeOnEscape: false,
				width	: 'auto',
				title	: Loc.g("Redimensionner votre image"),
				buttons	: [
					{
						text 	: Loc.g("Redimensionner"),
						'class'	: 'btn btn-default',
						click 	: function(){
							if (checkCoords()){
								$("#jc-form").submit();
							}
						}
					},
					{
						text 	: Loc.g("Redimension automatique"),
						'class'	: 'btn btn-primary',
						click 	: function(){
							$('#jc-autocrop').val('Y');
							$("#jc-form").submit();
						}}
				],
				callback	: function(){Galery.prepareCrop(galeryId);}
			};

			MyWindow.load("galery", {action:"cropForm", jcfid:data.file_infos.file_id, galeryId:galeryId}, options);
		}
	},
	
	prepareCrop: function(galeryId){

		var formId = "jc-form";
		var options = {success:function(data){Galery.refreshLast(data); MyWindow.close();}, dataType:"json"};
		var curData = {action: 'cropImage', galeryId: galeryId};
		MyForm.prepare(formId, "galery&"+$.param(curData), options, true);
		$('#jc-image').Jcrop({
			onSelect: updateCoords,
			onChange: updateCoords,
			boxWidth : 600,
			boxHeight : 600,
			setSelect:   [ 100, 100, 50, 50 ],
			aspectRatio: 1,
			bgColor: ''
		});
		
	},
	
	deleteImage: function (id){
		
		var msg =  Loc.g("Voulez vous supprimer l'image de la galerie ?");
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Supprimer l’image"),
			buttons		: [
				{text: Loc.g("Non"), click : function(){$(this).dialog("close");}},
                {text: Loc.g("Oui"), click : function(){Galery.doDeleteImage(id);$(this).dialog("close");}},
            ]
		};

		MyWindow.alert(msg, options);
		
	},
	
	doDeleteImage: function(id){
		
		MyFacture.post( 'galery', {'action':"deleteItemGalery", "id": id},
			function(data){
				
				$('#'+id).remove();
				
				var firstImage = $('.image-thumb').not('.main-image-row').first();
				firstImage.find('.image-row').click();
				
				if ($('.galery-images .default-yes').length === 0){
					var firstId = firstImage.attr('id');
					Galery.setDefaultImage(firstId);
				}
				
				if ($('.image-row').length === 1){
					
					// $('.galery-image img.main').attr('src','/ressources/logged/img/common/galery_placeholder_200.png').fadeIn();
					$('.galery-container .no-image').show();
					$('.galery-images, .galery-image').hide();				

					// $('.main-details .avatar-picture img').attr('src', '/ressources/logged/img/common/galery_placeholder_200.png');
				}
				
		}, "json");
		
	},
	
	setDefaultImage: function(id, declid){
		
		if(undefined===declid){
			declid = 0;
		}		
		
		MyFacture.post( 'galery', {action:"setDefaultItemImage", id: id, declid : declid},
			function(data){
				$('.galery-images .default-yes').removeClass('default-yes');
				$('#'+id).addClass('default-yes');
				
				var defaultImg = $('#'+id).find('img').attr('src');
				$('.main-details .avatar-picture img').attr('src', defaultImg);

				$(".galery-images .image-thumb .button-default i").attr('class', "icon-star");	
				$('#' + id + " .button-default i").attr('class', "icon-star-full");			
		}, "json");
		
	}
	
};

function updateCoords(c) {
	
	$('.ui-dialog #jc-x').val(c.x);
	$('.ui-dialog #jc-y').val(c.y);
	$('.ui-dialog #jc-w').val(c.w);
	$('.ui-dialog #jc-h').val(c.h);
	
};

function checkCoords(){
	
	if (parseInt($('.ui-dialog #jc-w').val())){
		return true;
	}  else {
		MyWindow.alert(Loc.g('Vous devez selectionner une région avant de redimensionner'), {type:'error'});
		return false;
	}
	
};